/**
 * Reordering, for the endpoints that renumber a list.
 *
 * Every ordering endpoint in the API — scene aspects, panels, case scenes, comic scenes,
 * comic pages — takes a **complete** list of ids and rejects a partial one, because the
 * rows left unnamed would keep stale positions. So the client's job is always the same:
 * produce the whole array with one item moved.
 */

/** The list with the item at `from` reinserted at `to`. Every other id keeps its order. */
export function moved(ids: readonly number[], from: number, to: number): number[] {
  const next = [...ids]
  const [item] = next.splice(from, 1)
  if (item !== undefined) next.splice(to, 0, item)
  return next
}
